export default __webpack_public_path__ + "static/media/ups.c2a8e38f.svg";